import type { IconProps } from '../Icon.Types'

import { ArrowDownIcon } from './ArrowDownIcon'

export const ArrowUpIcon = (props: IconProps) => (
  <ArrowDownIcon {...props} transform="rotate(180)" />
)
